import {
  Avatar,
  Box,
  Button,
  Menu,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { ArrowBackBlue } from 'Images';
import { useEffect, useState } from 'react';
import { ActiveFiltersBubble } from './ActiveFiltersBubble';

interface IControlledDropdown {
  label: string;
  button?: {
    sx?: SxProps;
    buttonImageSrc?: string;
    buttonImageSx?: SxProps;
    buttonText?: string;
    buttonTextSx?: SxProps;
    buttonHoverImageSrc?: string;
  };
  hideIcon?: boolean;
  hideLine?: boolean;
  menuPaper?: {
    sx?: SxProps;
  };
  filterComponent?: React.ReactNode;
  activeFilters?: number;
  closeOnEffect?: any;
}

export const ControlledDropdown = ({
  label,
  button,
  hideIcon,
  hideLine,
  menuPaper,
  filterComponent,
  activeFilters,
  closeOnEffect,
}: IControlledDropdown) => {
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const [isHover, setIsHover] = useState<boolean>(false);

  const openDropdownHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget as Element);
    setOpenDropdown(!openDropdown);
  };

  const closeDropdownHandler = () => {
    setOpenDropdown(false);
    setAnchorEl(null);
  };

  useEffect(() => {
    setOpenDropdown(false);
    setAnchorEl(null);
  }, [closeOnEffect]);

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      {activeFilters !== undefined && activeFilters > 0 && (
        <ActiveFiltersBubble activeFiltersAmount={activeFilters} />
      )}
      <Button
        sx={{
          p: openDropdown ? '10px 16px 15px 16px' : '10px 16px 10px 16px',
          bgcolor: '#FFF',
          border: '1px solid',
          borderColor: '#1552E8',
          borderRadius: openDropdown ? '12px 12px 0px 0px' : '32px',
          borderBottom: openDropdown ? 'none' : undefined,
          gap: '4px',
          ...button?.sx,
        }}
        onClick={openDropdownHandler}
        onMouseOver={() => setIsHover(true)}
        onMouseOut={() => setIsHover(false)}
      >
        <Typography variant='body1' sx={{ ...button?.buttonTextSx }}>
          {label}
        </Typography>
        {hideIcon ? null : (
          <Avatar
            alt=''
            src={
              isHover && button?.buttonHoverImageSrc
                ? button?.buttonHoverImageSrc
                : button?.buttonImageSrc || ArrowBackBlue
            }
            sx={{
              width: '16px',
              height: '16px',
              transform: openDropdown ? 'rotate(90deg)' : 'rotate(-90deg)',
              ...button?.buttonImageSx,
            }}
          />
        )}
      </Button>
      <>
        {openDropdown && !hideLine && (
          <Box
            sx={{
              position: 'absolute',
              bottom: '-2px',
              left: '2px',
              zIndex: 1500,
              width: 'calc(100% - 4px)',
              height: '5px',
              bgcolor: '#FFF',
            }}
          ></Box>
        )}
        <Menu
          open={openDropdown}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          onClose={closeDropdownHandler}
          PaperProps={{
            sx: {
              mr: '-1px',
              bgcolor: '#FFF',
              borderRadius: '0 16px 16px 16px',
              border: '1px solid',
              borderColor: '#1552E8',
              boxShadow: 'none',
              '& ul': {
                p: 0,
              },
              ...menuPaper?.sx,
            },
          }}
        >
          <Stack
            tabIndex={-1}
            sx={{
              width: '300px',
              maxHeight: '250px',
              p: 0,
              overflowX: 'hidden',
            }}
          >
            {filterComponent}
          </Stack>
        </Menu>
      </>
    </Box>
  );
};
